import { Box, IconButton } from "@mui/material";
import { MaterialReactTable } from "material-react-table";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
} from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { loadingOn } from "../../../../Utils/utils";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Tooltip,
} from "@material-ui/core";
import "../../../User/VUser.scss";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import LastPageIcon from "@mui/icons-material/LastPage";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import {
  addNodeInfo,
  deleteNodeInfo,
  getNodeInfo,
  updateNodeInfo,
} from "../../../../Utils/actions";
import { IS_SUCCESS } from "../../../../Utils/constants/action-types";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  FormHelperText,
} from "@mui/material";
import { buttonStyle } from "../../../../Style/ManualStyle";
import Cluster from "../cluster";

const ShowAllNodeInfo = ({}) => {
  const { allNodeInfo, nodeInfoTableCount, isSuccess } = useSelector(
    (state) => state.data
  );
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [deleteRow, setDeleteRow] = useState({});
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [deleteConfirm, setDeleteConfirm] = useState(false);
  const [pageIndexNodeInfo, setPageIndexNodeInfo] = useState(0);
  const [pageSizeNodeInfo, setPageSizeNodeInfo] = useState(
    sessionStorage.getItem("nodePageSize")
      ? sessionStorage.getItem("nodePageSize")
      : 10
  );
  const [nodeInfoTablePagination, setNodeInfoTablePagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [isAddressEnabled, setIsAddressEnabled] = useState(true);
  const [tableData, setTableData] = useState(allNodeInfo);
  const [isConfirm, setIsConfirm] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [errors, setErrors] = useState({});

  const initialState = {
    port: "",
    address: "",
    name: "",
    priority: "",
    isMaster: "",
    isActive: "",
  };
  const [cluster, setCluster] = useState(initialState);
  const Master = ["True", "False"];

  useEffect(() => {
    if (isSuccess) {
      dispatch({
        type: IS_SUCCESS,
        payload: false,
      });
      setIsConfirm(true);
    } else {
      setIsConfirm(false);
    }
  }, [isSuccess]);

  sessionStorage.setItem("nodePageSize", pageSizeNodeInfo);
  const columns = useMemo(() => {
    const baseColumns = [
      // {
      //     accessorKey: "id",
      //     header: "Id",
      //     enableEditing: false,  // Custom property to control visibility
      // },
      {
        accessorKey: "port",
        header: "Port",
        visible: true,
        muiEditTextFieldProps: {
          type: "number",
          required: true,
        },
      },
      {
        accessorKey: "name",
        header: "Name",
        visible: true,
      },
      {
        accessorKey: "priority",
        header: "Priority",
        visible: true,
        muiEditTextFieldProps: {
          type: "number",
          required: true,
        },
      },
      {
        accessorKey: "isMaster",
        header: "Master",
        visible: true,
      },
      {
        accessorKey: "isActive",
        header: "Active",
        visible: true,
      },
    ];

    baseColumns.splice(1, 0, {
      accessorKey: "address",
      header: "Address",
      enableEditing: isAddressEnabled, // Set to true if you want it to show
    });

    // Filter out columns where visible is false
    return baseColumns.filter((column) => column.visible !== false);
  }, [isAddressEnabled, tableData]);

  const handleClick = () => {
    setOpenDialog(true);
  };

  const handleClose = () => {
    setOpenDialog(false);
  };

  useEffect(() => {
    dispatch(getNodeInfo(pageSizeNodeInfo, pageIndexNodeInfo));
    setNodeInfoTablePagination({
      pageIndex: pageIndexNodeInfo - 1,
      pageSize: pageSizeNodeInfo,
    });
  }, [pageSizeNodeInfo, pageIndexNodeInfo]);

  const cmpntGroup =
    sessionStorage.getItem("cmpntGroup") !== null
      ? JSON.parse(sessionStorage.getItem("cmpntGroup"))
      : "{}";

  const handleDeleteCancel = () => {
    setDeleteConfirm(false);
    setDeleteConfirmOpen(false);
  };

  const handleDeleteConfirm = () => {
    // Handle delete logic here
    setDeleteConfirm(true);
    setDeleteConfirmOpen(false);
  };

  const openDeleteConfirmModal = (row) => {
    setDeleteConfirmOpen(true);
    setDeleteRow(row.original);
  };

  useEffect(() => {
    if (deleteConfirm) {
      setDeleteConfirm(false);
      dispatch(loadingOn());
      dispatch(deleteNodeInfo(deleteRow, pageSizeNodeInfo, pageIndexNodeInfo));
    }
  }, [deleteConfirmOpen]);

  const handlePageChange = (newPageIndex) => {
    setPageIndexNodeInfo(newPageIndex);
  };
  const handleStartChange = () => {
    setPageIndexNodeInfo(0);
  };

  const handleEndChange = () => {
    const totalPages = Math.ceil(nodeInfoTableCount / pageSizeNodeInfo);
    setPageIndexNodeInfo(totalPages - 1);
  };

  const handlePageSizeChange = (newPageSize) => {
    setPageSizeNodeInfo(newPageSize);
    setPageIndexNodeInfo(0);
  };

  const onhandleSave = ({ row, table }) => {
    dispatch(addNodeInfo(row?._valuesCache));
    if (!isConfirm) {
      table.setCreatingRow(null);
      setIsConfirm(false);
    }
  };

  const onEditNodeInfo = ({ row, table }) => {
    dispatch(updateNodeInfo(row?._valuesCache));
    if (!isConfirm) {
      table.setEditingRow(null);
      setIsConfirm(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCluster({
      ...cluster,
      [name]: value,
    });
    // Clear the specific field's error when the user starts typing
    setErrors({
      ...errors,
      [name]: "",
    });
  };

  const handleSave = () => {
    const newErrors = {};

    // Check for required fields
    if (!cluster.name) {
      newErrors.name = "Name is required";
    }
    if (!cluster.priority) {
      newErrors.priority = "Priority is required";
    }
    if (!cluster.address) {
      newErrors.address = "Address is required";
    }
    if (!cluster.port) {
      newErrors.port = "Port is required";
    }

    // Check for duplicate fields
    const isNameExists = allNodeInfo.some((item) => item.name === cluster.name);
    const isPriorityExists = allNodeInfo.some(
      (item) => item.priority === cluster.priority
    );
    const isAddressPortExists = allNodeInfo.some(
      (node) => node.address === cluster.address && node.port === cluster.port
    );

    if (isNameExists) {
      newErrors.name = "Name already exists!";
    }
    if (isPriorityExists) {
      newErrors.priority = "Priority already exists!";
    }
    if (isAddressPortExists) {
      newErrors.port = "Combination of Address and Port already exists.";
    }

    // Update errors state if there are any validation errors
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    // If no errors, proceed to dispatch
    dispatch(addNodeInfo(cluster));
    handleClose(); // Close dialog if fields are valid
    dispatch(getNodeInfo(pageSizeNodeInfo, pageIndexNodeInfo));
  };

  useEffect(() => {
    if (openDialog) {
      setCluster(initialState);
      setErrors({});
    }
  }, [openDialog]);

  const commonSx = {
    width: "180px",
    marginRight: "4px",
    "& .MuiInputBase-root": {
      overflow: "hidden",
      height: "35px",
      position: "relative",
      marginBottom: "10px",
    },
    "& .MuiPickersToolbar-root": {
      minHeight: "24px",
    },
    '& .MuiInputLabel-root[data-shrink="true"]': {
      top: "0px",
    },
    '& .MuiInputLabel-root[data-shrink="false"]': {
      top: "-8px",
    },
  };

  return (
    <>
      <div
        className="add-role-content"
        style={{
          display: "block",
          width: "100%",
          overflow: "auto",
          padding: "15px 15px",
          backgroundColor: "#242424",
        }}
      >
        <Cluster/>
        <MaterialReactTable
          muiTableHeadCellProps={{
            sx: {
              backgroundColor: "#2e2e2e", // dark head
              color: "#ccc",
            },
          }}
          muiTableHeadProps={{
            sx: {
              overflow: "auto",
              backgroundColor: "#2e2e2e",
              "&::-webkit-scrollbar": {
                width: "12px",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#444", // darker thumb
                borderRadius: "6px",
              },
              "&::-webkit-scrollbar-thumb:hover": {
                backgroundColor: "#555",
              },
              "&::-webkit-scrollbar-track": {
                backgroundColor: "#2e2e2e",
              },
            },
          }}
          muiTableHeadCellContentProps={{
            sx: {
              color: "#ccc !important", // text color
              "& svg": {
                color: "#ccc !important", // sort icon color
              },
            },
          }}
          muiTableBodyProps={{
            sx: {
              overflow: "auto",
              scrollbarWidth: "thin",
              backgroundColor: "#181818", // dark body
              "&::-webkit-scrollbar": {
                width: "12px",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#444",
                borderRadius: "6px",
              },
              "&::-webkit-scrollbar-thumb:hover": {
                backgroundColor: "#555",
              },
              "&::-webkit-scrollbar-track": {
                backgroundColor: "#23272f",
              },
              // "& tr:nth-of-type(odd)": {
              //   backgroundColor: "#23272f",
              // },
              // "& tr:nth-of-type(even)": {
              //   backgroundColor: "#181818",
              // },
              "& td": {
                padding: "0.5rem",
                borderBottom: "1px solid #333",
                color: "#c7c7c7",
              },
            },
          }}
          muiTabEditIconleHeadCellProps={{
            sx: {
              backgroundColor: "#286685",
              color: "#fff",
            },
          }}
          muiTableProps={{
            sx: {
              overflow: "scroll",
              border: "none",
            },
          }}
          muiTablePaperProps={{
            sx: {
              boxShadow: "none",
              height: "auto",
              width: "100%",
              position: "static",
              display: "block",
              overflowY: "auto",
              overflowX: "auto",
              backgroundColor: "#23272f", // dark table background
              scrollbarWidth: "thin",
              "&::-webkit-scrollbar": {
                width: "12px",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#444",
                borderRadius: "6px",
              },
              "&::-webkit-scrollbar-thumb:hover": {
                backgroundColor: "#555",
              },
              "&::-webkit-scrollbar-track": {
                backgroundColor: "#23272f",
              },
            },
          }}
          muiTableContainerProps={{
            sx: {
              maxHeight: "60vh",
              overflowY: "auto",
              overflowX: "auto",
            },
          }}
          muiTableBodyRowProps={({ row, index }) => ({
            sx: {
              backgroundColor: row.getIsSelected()
                ? "#1c1c1c"
                : // : index % 2 === 0
                  //     ? "#cfd5e959"
                  "#121212",
            },
          })}
          enableStickyFooter={true}
          enableStickyHeader={true}
          columns={columns}
          data={allNodeInfo}
          enableRowActions
          createDisplayMode="row"
          positionActionsColumn="last"
          onCreatingRowSave={onhandleSave}
          onCreatingRowCancel={({ row, table }) => {
            setIsAddressEnabled(true);
            table.setCreatingRow(null);
          }}
          editDisplayMode={"row"}
          enableEditing={true}
          onEditingRowCancel={({ row, table }) => {
            setIsAddressEnabled(true);
            table.setEditingRow(null);
          }}
          onEditingRowSave={onEditNodeInfo}
          enableDensityToggle={false}
          getRowId={(row) => row.id}
          enableFullScreenToggle={false}
          enableFilters={false}
          enableHiding={false}
          muiPaginationProps={({ table }) => ({
            showRowsPerPage: true,
          })}
          rowCount={nodeInfoTableCount}
          state={nodeInfoTablePagination}
          renderTopToolbar={({ table, row }) => (
            <div
              className="d-flex w-100 justify-content-end"
              style={{ background: "#181818" }}
            >
              {cmpntGroup["nodeInfo"]?.Add && (
                <Tooltip title="Create Node Info">
                  <Button
                    startIcon={<AddIcon />}
                    style={{
                      ...buttonStyle,
                      // backgroundColor: "#286685",
                      // color: "#fff",
                      marginRight: "10px",
                      width: "100px",
                      marginBottom: "10px",
                      marginTop: "10px",
                    }}
                    onClick={handleClick}
                  >
                    Create
                  </Button>
                </Tooltip>
              )}
            </div>
          )}
          enablePagination={false}
          renderBottomToolbarCustomActions={({ table }) => (
            <>
              <div style={{ marginLeft: "auto", color: "c7c7c7" }}>
                <span>Rows per Page </span>&nbsp;
                <FormControl variant="standard" size="small">
                  <Select
                    value={pageSizeNodeInfo}
                    onChange={(e) =>
                      handlePageSizeChange(Number(e.target.value))
                    }
                    sx={{
                      color: "#c7c7c7",
                      ".MuiSelect-icon": { color: "#c7c7c7" },
                      ".MuiOutlinedInput-notchedOutline": {
                        borderColor: "#444",
                      },
                    }}
                  >
                    <MenuItem value={5}>5</MenuItem>
                    <MenuItem value={10}>10</MenuItem>
                    <MenuItem value={20}>20</MenuItem>
                    <MenuItem value={50}>50</MenuItem>
                    <MenuItem value={100}>100</MenuItem>
                  </Select>
                </FormControl>
                &nbsp;
                <span>
                  {pageIndexNodeInfo * pageSizeNodeInfo + 1}-
                  {Math.min(
                    pageIndexNodeInfo * pageSizeNodeInfo + pageSizeNodeInfo,
                    nodeInfoTableCount
                  )}{" "}
                  of &nbsp;
                  {nodeInfoTableCount}&nbsp;
                </span>
                <FirstPageIcon
                  onClick={() => {
                    if (pageIndexNodeInfo !== 0) {
                      handleStartChange();
                    }
                  }}
                  style={{
                    cursor: pageIndexNodeInfo === 0 ? "not-allowed" : "pointer",
                    color:
                      pageIndexNodeInfo === 0
                        ? "rgba(255,255,255,0.26)"
                        : "#c7c7c7",
                  }}
                />
                <NavigateBeforeIcon
                  onClick={() => {
                    if (pageIndexNodeInfo !== 0) {
                      handlePageChange(pageIndexNodeInfo - 1);
                    }
                  }}
                  style={{
                    cursor: pageIndexNodeInfo === 0 ? "not-allowed" : "pointer",
                    color:
                      pageIndexNodeInfo === 0
                        ? "rgba(255,255,255,0.26)"
                        : "#c7c7c7",
                  }}
                />
                <NavigateNextIcon
                  onClick={() => {
                    if (
                      (pageIndexNodeInfo + 1) * pageSizeNodeInfo <
                      nodeInfoTableCount
                    ) {
                      handlePageChange(pageIndexNodeInfo + 1);
                    }
                  }}
                  style={{
                    cursor:
                      (pageIndexNodeInfo + 1) * pageSizeNodeInfo >=
                      nodeInfoTableCount
                        ? "not-allowed"
                        : "pointer",
                    color:
                      (pageIndexNodeInfo + 1) * pageSizeNodeInfo >=
                      nodeInfoTableCount
                        ? "rgba(255,255,255,0.26)"
                        : "#c7c7c7",
                  }}
                />
                <LastPageIcon
                  onClick={() => {
                    if (
                      (pageIndexNodeInfo + 1) * pageSizeNodeInfo <
                      nodeInfoTableCount
                    ) {
                      handleEndChange();
                    }
                  }}
                  style={{
                    cursor:
                      (pageIndexNodeInfo + 1) * pageSizeNodeInfo >=
                      nodeInfoTableCount
                        ? "not-allowed"
                        : "pointer",
                    color:
                      (pageIndexNodeInfo + 1) * pageSizeNodeInfo >=
                      nodeInfoTableCount
                        ? "rgba(255,255,255,0.26)"
                        : "#c7c7c7",
                  }}
                />
              </div>
            </>
          )}
          // onEditingRowSave={onEditHandle}
          renderRowActions={({ row, table }) => (
            <Box sx={{ display: "flex", flexWrap: "nowrap", gap: "8px" }}>
              {/* {(cmpntGroup["nodeInfo"]?.Update) && (<Tooltip title="Edit Node Info">
                            <IconButton
                                sx={{ color: "#286685" }}
                                onClick={() => {
                                    table.setEditingRow(row);
                                    setIsAddressEnabled(false)
                                }}
                            >
                                <EditIcon />
                            </IconButton>
                        </Tooltip>)} */}
              {cmpntGroup["nodeInfo"]?.Delete && (
                <Tooltip title="Delete Node Info">
                  <IconButton
                    onClick={() => {
                      openDeleteConfirmModal(row);
                      // data.splice(row.index, 1); //assuming simple data table
                      // setData([...allUserdata]);
                    }}
                  >
                    <DeleteIcon sx={{ color: "#c7c7c7" }} />
                  </IconButton>
                </Tooltip>
              )}
            </Box>
          )}
        />
        <div>
          <Dialog open={deleteConfirmOpen} onClose={handleDeleteCancel}>
            <DialogTitle
              style={{ backgroundColor: "#161616", color: "#c7c7c7" }}
            >
              Delete Confirmation
            </DialogTitle>
            <DialogContent>
              <p>Are you sure you want to delete the item?</p>
            </DialogContent>
            <DialogActions>
              <Button
                style={buttonStyle}
                startIcon={<CloseIcon />}
                onClick={handleDeleteCancel}
                variant="contained"
              >
                Cancel
              </Button>
              <Button
                startIcon={<DeleteIcon />}
                style={buttonStyle}
                onClick={handleDeleteConfirm}
                color="error"
              >
                Delete
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      </div>

      {openDialog && (
        <>
          <Dialog
            open={openDialog}
            onClose={handleClose}
            aria-describedby="alert-dialog-slide-description"
          >
            <div
              className="d-flex justify-content-between"
              style={{ backgroundColor: "#161616", color: "#c7c7c7" }}
            >
              <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                Create Cluster
              </DialogTitle>
              <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={{
                  position: "absolute",
                  right: 8,
                  color: "white",
                }}
              >
                <CloseIcon />
              </IconButton>
            </div>
            <DialogContent dividers style={{ backgroundColor: "#242424" }}>
              <Typography gutterBottom>
                <div>
                  <TextField
                    sx={commonSx}
                    id="name"
                    name="name"
                    label="Name"
                    variant="outlined"
                    onChange={handleChange}
                    required
                    error={!!errors.name}
                    helperText={errors.name}
                    value={cluster.name}
                  />

                  <TextField
                    sx={commonSx}
                    id="address"
                    name="address"
                    label="Address"
                    variant="outlined"
                    onChange={handleChange}
                    required
                    error={!!errors.address}
                    helperText={errors.address}
                    value={cluster.address}
                  />

                  <TextField
                    sx={commonSx}
                    type="number"
                    id="port"
                    name="port"
                    label="Port"
                    variant="outlined"
                    onChange={handleChange}
                    required
                    error={!!errors.port}
                    helperText={errors.port}
                    value={cluster.port}
                  />

                  <TextField
                    sx={commonSx}
                    type="number"
                    id="priority"
                    name="priority"
                    label="Priority"
                    variant="outlined"
                    onChange={handleChange}
                    required
                    error={!!errors.priority}
                    helperText={errors.priority}
                    value={cluster.priority}
                  />

                  <FormControl sx={commonSx}>
                    <InputLabel>Is Master</InputLabel>
                    <Select
                      name="isMaster"
                      value={cluster.isMaster}
                      onChange={handleChange}
                      label="Is Master"
                    >
                      {Master?.map((secure) => (
                        <MenuItem key={secure} value={secure}>
                          {secure}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <FormControl sx={commonSx}>
                    <InputLabel>Is Active</InputLabel>
                    <Select
                      name="isActive"
                      value={cluster.isActive}
                      onChange={handleChange}
                      label="Is Active"
                    >
                      {Master?.map((secure) => (
                        <MenuItem key={secure} value={secure}>
                          {secure}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
              </Typography>
            </DialogContent>
            <DialogActions style={{ backgroundColor: "#161616" }}>
              <Button
                variant="secondary"
                onClick={handleClose}
                style={{ ...buttonStyle }}
              >
                Close
              </Button>
              <Button
                variant="primary"
                onClick={handleSave}
                style={{
                  ...buttonStyle,
                  backgroundColor: "rgb(26 101 129)",
                  color: "white",
                }}
              >
                Save
              </Button>
            </DialogActions>
          </Dialog>
        </>
      )}
    </>
  );
};

export default ShowAllNodeInfo;
